import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDriverUnavailability } from '../../api/driver'; 
import {keyUri,config }from '../../key'
import axios from 'axios';
import { toast } from 'react-toastify';
import { ArrowBack } from "@mui/icons-material";

const AssignmentForm = () => {
    const dispatch = useDispatch();
     const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Go to previous page
  };
    const driverId = localStorage.getItem("driverid") || localStorage.getItem("Driver");

    const [formData, setFormData] = useState({
        from: null,
        to: null,
        reason: '',
    });

    const handleDateChange = (date, field) => {
        setFormData({ ...formData, [field]: date });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.from || !formData.to || !formData.reason) {
            alert("Please fill in all fields");
            return;
        }

        const payload = {
            from: formData.from.toISOString(),
            to: formData.to.toISOString(),
            reason: formData.reason,
        };

        try {
          const response = await axios.post(
            `${keyUri.BACKEND_URI}/api/pushunavailability/${driverId}`,
            payload,
            config
          );
            setFormData({
                from: null,
                to: null,
                reason: '',
            })
            toast.success(response.data.message, {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
        } catch (error) {
            console.error('Error submitting:', error);
            alert('Something went wrong!');
        }
    };

    return (
        <div className="flex items-center justify-center bg-gradient-to-r from-indigo-600 via-purple-500 to-pink-500 pb-10 mt-32">
            
            <div className="w-full max-w-2xl bg-white p-[3.8rem] rounded-xl shadow-2xl border-2 border-gray-300 mt-12">
                 <div
      onClick={handleBack}
      className="flex items-center gap-2 cursor-pointer text-blue-600 hover:underline -mt-8 -ml-8"
    >
      <ArrowBack />
      <span>Back</span>
    </div>
                <h2 className="text-3xl font-semibold text-center text-gray-800 mb-6">Add Unavailability</h2>

                <form onSubmit={handleSubmit}>
                    {/* From Date */}
                    <div className="mb-6">
                        <label className="block text-lg font-medium text-gray-600 mb-2">
                            From Date <span className="text-sm text-gray-400">(dd/mm/yyyy)</span>
                        </label>
                        <DatePicker
                            selected={formData.from}
                            onChange={(date) => handleDateChange(date, 'from')}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="dd/mm/yyyy"
                            className="w-full border-2 border-gray-300 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                    </div>

                    {/* To Date */}
                    <div className="mb-6">
                        <label className="block text-lg font-medium text-gray-600 mb-2">
                            To Date <span className="text-sm text-gray-400">(dd/mm/yyyy)</span>
                        </label>
                        <DatePicker
                            selected={formData.to}
                            onChange={(date) => handleDateChange(date, 'to')}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="dd/mm/yyyy"
                            className="w-full border-2 border-gray-300 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                    </div>

                    {/* Reason */}
                    <div className="mb-6">
                        <label htmlFor="reason" className="block text-lg font-medium text-gray-600 mb-2">Reason</label>
                        <input
                            type="text"
                            id="reason"
                            name="reason"
                            value={formData.reason}
                            onChange={handleChange}
                            className="w-full border-2 border-gray-300 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            placeholder="Enter reason for unavailability"
                        />
                    </div>

                    <div className="mb-6 text-center">
                        <button
                            type="submit"
                            className="w-full py-3 px-6 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold text-lg rounded-xl hover:from-indigo-700 hover:to-purple-700 transition duration-300"
                        >
                            Set Unavailability
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AssignmentForm;
